import type { SerializedSeat } from './lib';

export const SEAT_EXAMPLE: SerializedSeat = {
  key: '0A',
  cabinClass: 'Economy',
  coordinates: {
    row: 0,
    col: 'A',
  },
  type: 'standard',
  pricing: {
    currency: '',
    total: '',
    converted: {
      total: '',
      rate: '',
      currency: 'KZT',
      modifiers: '',
    },
  },
  characteristics: null,
  available: true,
  exists: true,
  price: {
    amount: '',
    currency: 'KZT',
  },
};
export const BUSY_SEAT_EXAMPLE: SerializedSeat = {
  ...SEAT_EXAMPLE,
  available: false,
  exists: false,
};

export const UNSELECTED_SEAT = {
  seatKey: '',
  seatPrice: 0,
  originalSeatPrice: 0,
  coordinates: {
    row: 0,
    col: '',
  },
};

export const seatColors = [
  ['#FFF2D1', '#F6C13A'],
  ['#C4E9FB', '#3AB6F2'],
  ['#E1D2F5', '#9C6ADE'],
  ['#FDC5C2', '#F73D34'],
  ['#D5DAF7', '#7284E4'],
  ['#FFD7B3', '#F39846'],
  ['#BFEEDC', '#23E49A'],
  ['#99E2A9', '#0DDC3A'],
  ['#B3B3E2', '#5A5AE1'],
  ['#FFB8F0', '#F459D3'],
];
